import { OverlayTrigger, Tooltip } from "react-bootstrap";

const getLabelText = (
  value: any,
  options: { value: any; label: string }[] = [],
) => {
  if (!value || !options.length) return "";

  const valueArray = Array.isArray(value) ? value : [value];

  const labelMap = options.reduce<Record<string | number, string>>(
    (acc, option) => {
      acc[option.value] = option.label;
      return acc;
    },
    {},
  );

  return valueArray
    ?.map((val) => labelMap[val])
    ?.filter(Boolean)
    .join(", ");
};

export const DropdownWithTooltip = ({
  value,
  options,
  children,
}: {
  value: any;
  options: { value: any; label: string }[];
  children: React.ReactNode;
}) => {
  const text = getLabelText(value, options);

  if (!text) return <>{children}</>;

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-dynamic">{text}</Tooltip>}
    >
      <div style={{ width: "100%" }}>{children}</div>
    </OverlayTrigger>
  );
};
